module.exports = __webpack_public_path__ + "img/revenueAndExpenditureFirst.bd2cf075.svg";